<template>
    <table class="rawdata-table single">
        <tbody>
            <tr>
                <td v-for="(data, i) in raw" v-bind:key="i" class="rawdata" v-bind:class="!showAll ? 'collpased-col' : ''">
                    <i class="el-icon-more" v-if="!showAll && [0, 2, 3, 5, 6, 7].indexOf(i) > -1"></i>
                    <span v-else>{{data}}</span>
                </td>
                <td class="rawdata show-btn">
                    <a href="javascript:void(0)" @click="toggleShowAll">{{ showAll ? "hide all" : "show all" }}</a>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "raw-data-row",
    data() {
        return {
            showAll: true
        }
    },
    props: {
        raw: {
            type: Array,
            required: true
        }
    },
    methods: {
        toggleShowAll() {
            this.showAll = !this.showAll
        }
    }
}
</script>
<style lang="scss" scoped>
    .rawdata-table {
        border-collapse: collapse;
        width: 100%;
        .rawdata {
            background-color: #f8f8f8;
            max-width: auto !important;
            min-width: auto !important;
            width: auto;
            padding: 2px 15px;
            vertical-align: middle;
            text-align: center;
            border-left: 1px solid #cccccc;
            display: inline-table;
            span, i {
                display: block;
                padding: 2px 6px;
                font-size: 11px;
            }
            span {
                font-size: 11px;
                font-weight: 300;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #666666;
            }
            &:first-child {
                border-left: 0px solid #cccccc;
            }
            &.collpased-col {
                // width: 20px !important;
            }
        }
        .show-btn {
            background-color: unset;
            a {
                margin: 2px 0 3px 7px;
                display: block;
                font-size: 11px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #4a9bf9;
                text-decoration: none;
            }
        }
    }
</style>